import DataGrid from 'devextreme/ui/data_grid';
import { exportGridToExcel, exportGridToPdf } from './grid-export';

/**
 * Export de TODAS las dx-data-grid del portal.
 *
 * Desde DevExtreme 22 el boton de export nativo (dxo-export) ya no genera archivo: solo dispara
 * `onExporting` y espera que la app arme el .xlsx/.pdf (excel_exporter + exceljs). Ninguna grilla
 * del portal lo implementaba, asi que con DevExtreme 24.2 el boton no hacia nada. En vez de tocar
 * las 27 plantillas, se registra UNA vez un onExporting por defecto para todos los DataGrid
 * (DataGrid.defaultOptions) que usa el helper compartido grid-export.ts (el mismo de newcube:
 * booleanos a Yes/No, plan B si el exportador falla, aviso si algo sale mal).
 *
 * Llamar ANTES de crear cualquier widget (main.ts).
 */
export function registerGlobalGridExport(): void {
  DataGrid.defaultOptions({
    options: {
      onExporting: (e: any) => {
        const fileName = exportFileName(e.component);
        if (e.format === 'pdf') {
          exportGridToPdf(e.component, fileName, fileName);
        } else {
          exportGridToExcel(e.component, fileName);
        }
        e.cancel = true;   // el archivo lo arma el helper
      },
    },
  });
}

// Nombre del archivo: el que tenga configurado la grilla, si no el titulo de su toolbar
// (.cs-grid-title) o el de la pagina (.csg-title), y la fecha del dia.
function exportFileName(component: any): string {
  let base = '';
  try { base = component.option('export.fileName') || ''; } catch { base = ''; }
  if (!base) {
    const el: HTMLElement = component && component.element ? (component.element().get ? component.element().get(0) : component.element()) : null;
    const gridTitle = el && el.querySelector ? el.querySelector('.cs-grid-title h3') : null;
    const pageTitle = document.querySelector('.csg-title');
    base = (gridTitle && gridTitle.textContent) || (pageTitle && pageTitle.textContent) || 'CUBE export';
  }
  const clean = String(base).replace(/#\d+/g, '').replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim() || 'CUBE export';
  const d = new Date();
  const ymd = d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  return clean + ' ' + ymd;
}
